export const SORT_OPTIONS = [
  {
    value: 'updated_at desc',
    label: 'Created Desc',
  },
  {
    value: 'updated_at asc',
    label: 'Created Asc',
  },
  {
    value: 'video_info.title desc',
    label: 'Title Desc',
  },
  {
    value: 'video_info.title asc',
    label: 'Title Asc',
  },
  {
    value: 'views desc',
    label: 'Views Desc',
  },
  {
    value: 'views asc',
    label: 'Views Asc',
  },
]

export const AUTH_REQUIRED_PAGES = ['/', '/settings']
